import React from 'react';
import {
  IconButton,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../utils/init-firebase';
import CreateLockRequestDrawer from './CreateLockRequestDrawer';

export default function ConfirmLockRequest({ request, client, currentUser }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handleConfirm = async (requestData) => {
    try {
      // Update the request status
      await updateDoc(doc(db, 'RateLockRequests', request.id), {
        status: 'Locked',
        'Date Locked': serverTimestamp(),
        lockedBy: {
          email: currentUser.email,
          name: currentUser.displayName,
          photoURL: currentUser.photoURL,
          uid: currentUser.uid
        },
        // Store the original requested data
        requestedData: {
          rate: request.rate || 0,
          termDays: request.termDays || 0,
          points: request.points || 0,
          cost: request.cost || 0,
          pricingType: request.pricingType || 'LP',
          notes: request.notes || ''
        },
        // Store the confirmed data
        confirmedData: {
          rate: requestData.rate || 0,
          termDays: requestData.termDays || 0,
          points: requestData.points || 0,
          cost: requestData.cost || 0,
          pricingType: requestData.pricingType || 'LP',
          notes: requestData.notes || ''
        }
      });

      // Update the client document with the new rate
      await updateDoc(doc(db, 'Clients', client.id), {
        'Loan Details': {
          ...client['Loan Details'],
          'Rate': requestData.rate,
          'Floated or Locked': 'Locked'
        }
      });

      onClose();
      toast({
        title: 'Rate Locked!',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error confirming rate lock request:', error);
      toast({
        title: 'Error confirming rate lock request',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <IconButton
        icon={<FiCheck />}
        size="md"
        colorScheme="green"
        variant="ghost"
        onClick={onOpen}
        isDisabled={request.status !== 'Pending'}
      />

      <CreateLockRequestDrawer
        loanID={request.loanID}
        loanNumber={request.loanNumber}
        loanAmount={client['Loan Details']?.['Loan Amount']}
        initialValues={{
          rate: request.rate,
          termDays: request.termDays,
          points: request.points,
          cost: request.cost,
          pricingType: request.pricingType,
          notes: request.notes
        }}
        onSubmit={handleConfirm}
        isConfirmation={true}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
} 